/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';

export const ArrowUpDownIcon = (props: {
  color?: string;
  className?: string;
}) => {
  const { color = '#595959', className } = props;
  return (
    <svg
      className={classNames(className)}
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.40239 0.322014L6.57165 2.67204C6.50756 2.7538 6.56612 2.87202 6.66887 2.87312H7.87758L7.87758 6.26503C7.87775 6.29809 7.89095 6.32975 7.91433 6.35313C7.93771 6.37651 7.96937 6.38971 8.00243 6.38987L8.99901 6.38987C9.06751 6.38987 9.12386 6.33353 9.12386 6.26503L9.12386 2.87091L10.3326 2.87091C10.3559 2.87091 10.3787 2.86433 10.3985 2.85194C10.4182 2.83955 10.4341 2.82184 10.4442 2.80086C10.4544 2.77987 10.4584 2.75644 10.4559 2.73327C10.4533 2.71009 10.4443 2.68811 10.4298 2.66983L8.59905 0.322014C8.58754 0.306842 8.57267 0.29454 8.55561 0.28607C8.53856 0.2776 8.51977 0.273193 8.50072 0.273193C8.48168 0.273193 8.46289 0.2776 8.44583 0.28607C8.42877 0.294539 8.4139 0.306842 8.40239 0.322014ZM8.00243 9.60942C7.96937 9.60958 7.93771 9.62279 7.91433 9.64617C7.89095 9.66955 7.87775 9.70121 7.87758 9.73427L7.87869 13.1273H6.66998C6.64666 13.1273 6.62382 13.1339 6.60407 13.1462C6.58432 13.1586 6.56847 13.1763 6.55832 13.1973C6.54817 13.2183 6.54414 13.2417 6.54669 13.2649C6.54925 13.2881 6.55828 13.3101 6.57275 13.3284L8.40239 15.6773C8.45321 15.7414 8.54823 15.7414 8.59905 15.6773L10.4298 13.3273C10.4939 13.2455 10.4353 13.1273 10.3326 13.1262H9.12386L9.12386 9.73206C9.12386 9.66356 9.06751 9.60721 8.99901 9.60721L8.00243 9.60942Z"
        fill={color}
      />
    </svg>
  );
};
